import { User } from '../beans/User';
import { AuthService } from '../services/auth.service';
import { BlockUiService } from '../services/blockui.service';
import { Component, ViewContainerRef, HostListener } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { NomenclatureService } from '../services/nomenclature.service';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginComponent {

	username: string;
	password: string;

	errorMessage: string = "";

	constructor(private authService: AuthService,
		private nomService: NomenclatureService,
		private activatedRoute: ActivatedRoute,
		private blockUi: BlockUiService,
		private vcRef: ViewContainerRef,
		private router: Router) { }

	logIn() {
		this.authService.login(this.username, this.password).subscribe(
			loggedIn => {
				this.blockUi.stop();
				this.nomService.preloadAll();
				this.router.navigate(['/calendar']);
			},
			errorStatus => {
				if (errorStatus.status === 403) { // tuka ne trjabva da go ima tozi status ama za vseki sluchaj 
					this.errorMessage = 'Your account is blocked. Wait 5 minutes and try again!';
				} else if (errorStatus.status === 401) {
					console.log(errorStatus.error.message)
					this.errorMessage = errorStatus.error.message;
				}
				this.router.navigate(['/login']);

			});
	}

	@HostListener('document:keydown', ['$event'])
	onKeydownHandler(event: KeyboardEvent) {
		if (event.key === 'Enter') {
			this.logIn();
		}
	}
}
